import Vue from 'vue'
import configs from '@/config'

let resource = null

// Note: the previous Tenor client set a `Cache-Control: public, max-age=900`
// *request* header. That only hints to intermediaries; browsers cache responses
// based on the *response* headers our BE/CDN emit, so the request header had no
// real effect. Caching is delegated to the BE response now.
const actions = {
  search: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/search-gif`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const search = async (params = {}) => {
  const result = await resource.search({
    limit: params.limit,
    media_filter: params.media_filter,
    searchfilter: params.searchfilter,
    pos: params.pos,
    q: params.q,
  })

  return result.body
}

export default {
  initResource,
  search,
}
